import { hugggOperator } from './recipientBranding';

const getThemeLabel = (themeInfo) =>
  themeInfo?.brandingId ?? themeInfo?.model?.name ?? 'default';

export const getThemeModelLoader = (
  themeInfo = { label: null },
  operator = hugggOperator,
) => {
  const label = getThemeLabel(themeInfo);
  // A non-Huggg operator gets its own theme namespace so `theme === 'default'`
  // checks (login route, HugggLife) do not apply to it.
  const theme =
    operator.name === hugggOperator.name ? label : `${operator.name}:${label}`;
  const model = themeInfo?.model ?? {};

  return {
    theme,
    modelLoader: (theme) => {
      return {
        ...model,
        operator,
        ...(operator.showHugggPromotions
          ? {}
          : { shouldShowPoweredByHuggg: false }),
        ...(operator.isWelfare ? { isWelfare: true } : {}),
        ...(operator.logoSrc
          ? {
              logo: {
                height: '60px',
                ...model.logo,
                src: model.logo?.src || operator.logoSrc,
              },
            }
          : {}),
        name: theme,
      };
    },
  };
};
